// IE 2026 10 25 / ODOO-348878 (заказ Игоря: атрибут формы AttrCrossGrid — «шахматка»)
// Чистая логика атрибута AttrCrossGrid (без Vue, DOM и стора): две иерархические табличные части (строки × колонки) и значение на пересечении.
// Значение ячейки лежит в ИСТОЧНИКЕ — в строке rows[i].<cell_table>, найденной по ключу колонки (<key_binding>): поле <cell_value>; «выключенная» ячейка —
// строки нет, либо она совпадает с патчем cell_clear (напр. { use: false }), либо (без cell_clear) значение пусто. Запись/очистка/повторное включение — только
// эти функции; поля строки, не названные в cell_value / cell_create_defaults / cell_clear, и порядок строк не трогаются. Значение (id или объект ссылки) кладётся КАК ЕСТЬ.
// Компонент (AttrCrossGrid.vue) строит проекцию «строки × колонки» для вложенного AttrGrid: ячейка проекции — свойство-аксессор поверх источника (defineCells).
// Выключатели: fe.ux.crossGrid (весь механизм), fe.ux.crossGridUndoExact (журнал точного undo), fe.ux.crossGridUndoStep (выбор из списка — отдельная группа отката), fe.ux.crossGridEscCancel (Esc при открытом списке отменяет правку), fe.ux.crossGridToolbar (команды панели инструментов и меню таблицы вложенного грида — через обёртку) — дефолт ВКЛ, читает компонент, сюда приходит setting(key, def).
// Плоский режим (IE 2026 10 25 / ODOO-348925, схема PLAN-MAP-SET v3): объявлены cell_rows_key_binding и cell_columns_key_binding — ячейки лежат не в rows[i].<cell_table>, а в ОДНОЙ таблице
// записи по абсолютному пути cell_table_binding (doc.node_fields); строка ячейки — первая строка с парой ключей <cell_rows_key> = ключ строки (key_binding строки rows_binding) и
// <cell_columns_key> = ключ колонки. Создание — {<оба ключа>, <cell_value>, ...cell_create_defaults} в конец таблицы; очистка, повторное включение, снимок / откат — те же функции.
// Корень таблицы даёт компонент: cfg.flat_root() → запись. Поиск пары — индекс Map (fe.ux.crossGridFlatIndex; выкл — линейный проход). Выключатель fe.ux.crossGridFlat.
// Юнит-тест: node --test tests/unit/crossGrid.test.mjs
export const CG_FLAG = 'fe.ux.crossGrid'   // IE 2026 10 25 / ODOO-348878
export const CG_FLAG_UNDO = 'fe.ux.crossGridUndoExact'   // IE 2026 10 25 / ODOO-348878
export const CG_FLAG_STEP = 'fe.ux.crossGridUndoStep'   // IE 2026 10 25 / ODOO-348878: каждый выбор из списка — своя группа отката (одно нажатие Ctrl+Z / Ctrl+Shift+Z — один шаг)
export const CG_FLAG_ESC = 'fe.ux.crossGridEscCancel'   // IE 2026 10 25 / ODOO-348878: Esc при открытом списке подбора отменяет правку ячейки (а не только закрывает список)
export const CG_FLAG_TOOLBAR = 'fe.ux.crossGridToolbar'   // IE 2026 10 25 / ODOO-348878: кнопки панели инструментов и пункты меню таблицы ☰ вложенного грида (Undo / Redo / история, Copy / Export …) доходят до него через обёртку
export const CG_FLAG_FIT = 'fe.ux.crossGridRowFit'   // IE 2026 10 25 / ODOO-348878: выбранная строка целиком в видимой полосе (последняя строка не под скроллбаром)
export const CG_FLAG_FLAT = 'fe.ux.crossGridFlat'   // IE 2026 10 25 / ODOO-348925: плоский режим (ячейки — строки одной таблицы записи с ключами строки и колонки); выкл — такое объявление показывает «не настроено»
export const CG_FLAG_FLAT_INDEX = 'fe.ux.crossGridFlatIndex'   // IE 2026 10 25 / ODOO-348925: поиск ячейки плоской таблицы по индексу пар ключей; выкл — линейный проход по таблице
export const CG_DEFAULT_WIDTH = 32   // IE 2026 10 25 / ODOO-348878: узкий лист — символ или чекбокс
// IE 2026 10 25 / ODOO-348925 (замечания ie-dm7 #104334 к шахматкам схемы PLAN-MAP-SET v3): вид листов. Выключатели (дефолт ВКЛ):
export const CG_FLAG_HDR = 'fe.ux.crossGridHeaderFit'   // IE 2026 10 25 / ODOO-348925: заголовок листа читаем — повёрнутый (узкие листы) или перенос по словам, высота ряда шапки по тексту
export const CG_FLAG_SHORT = 'fe.ux.crossGridCellShort'   // IE 2026 10 25 / ODOO-348925: в ячейке — короткая форма элемента словаря (short / symbol), если она есть
export const CG_FLAG_WRAP = 'fe.ux.crossGridCellWrap'   // IE 2026 10 25 / ODOO-348925: текст ячейки шире листа — перенос по словам, высота строки по тексту

function flagOn(setting, key) {
    try { return (typeof setting === 'function' ? setting(key, true) : true) !== false } catch (e) { return true }
}
export function crossGridOn(setting) { return flagOn(setting, CG_FLAG) }
export function crossGridUndoExactOn(setting) { return flagOn(setting, CG_FLAG_UNDO) }
export function crossGridRowFitOn(setting) { return flagOn(setting, CG_FLAG_FIT) }
export function crossGridUndoStepOn(setting) { return flagOn(setting, CG_FLAG_STEP) }   // IE 2026 10 25 / ODOO-348878
export function crossGridEscCancelOn(setting) { return flagOn(setting, CG_FLAG_ESC) }   // IE 2026 10 25 / ODOO-348878
export function crossGridToolbarOn(setting) { return flagOn(setting, CG_FLAG_TOOLBAR) }   // IE 2026 10 25 / ODOO-348878
export function crossGridFlatOn(setting) { return flagOn(setting, CG_FLAG_FLAT) }   // IE 2026 10 25 / ODOO-348925
export function crossGridFlatIndexOn(setting) { return flagOn(setting, CG_FLAG_FLAT_INDEX) }   // IE 2026 10 25 / ODOO-348925
export function crossGridHeaderFitOn(setting) { return flagOn(setting, CG_FLAG_HDR) }   // IE 2026 10 25 / ODOO-348925
export function crossGridCellShortOn(setting) { return flagOn(setting, CG_FLAG_SHORT) }   // IE 2026 10 25 / ODOO-348925
export function crossGridCellWrapOn(setting) { return flagOn(setting, CG_FLAG_WRAP) }   // IE 2026 10 25 / ODOO-348925

// ---------- общие мелочи ----------
const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
export function clone(v) { return v === undefined ? undefined : JSON.parse(JSON.stringify(v)) }
export function jsonEq(a, b) {
    if (a === b) return true
    if (a === null || a === undefined || b === null || b === undefined) return a == b
    if (typeof a !== 'object' || typeof b !== 'object') return false
    if (Array.isArray(a) !== Array.isArray(b)) return false
    const ka = Object.keys(a), kb = Object.keys(b)
    if (ka.length !== kb.length) return false
    return ka.every((k) => Object.prototype.hasOwnProperty.call(b, k) && jsonEq(a[k], b[k]))
}
export function escHtml(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

// точечные пути без фильтров; setPath создаёт промежуточные объекты
export function getPath(obj, path) {
    if (obj === null || obj === undefined || path === null || path === undefined || path === '') return undefined
    let cur = obj
    for (const p of String(path).split('.')) {
        if (cur === null || cur === undefined || typeof cur !== 'object') return undefined
        cur = cur[p]
    }
    return cur
}
export function setPath(obj, path, value) {
    const parts = String(path).split('.')
    let cur = obj
    for (let i = 0; i < parts.length - 1; i++) {
        const p = parts[i]
        if (cur[p] === null || cur[p] === undefined || typeof cur[p] !== 'object') cur[p] = {}
        cur = cur[p]
    }
    cur[parts[parts.length - 1]] = value
}
export function delPath(obj, path) {
    const parts = String(path).split('.')
    const parent = parts.length === 1 ? obj : getPath(obj, parts.slice(0, -1).join('.'))
    if (parent && typeof parent === 'object') delete parent[parts[parts.length - 1]]
}

// ---------- подписи ----------
// localized: поле на языке пользователя (<key>_<lang>), иначе базовое (<key>); числа — строкой
export function localized(obj, key, lang) {
    if (!obj || typeof obj !== 'object' || !key) return ''
    const loc = lang ? obj[`${key}_${lang}`] : undefined
    const v = (typeof loc === 'string' && loc !== '') ? loc : obj[key]
    return v === null || v === undefined ? '' : String(v)
}
// itemTitle: символ/подпись элемента словаря — title_<lang>, иначе перевод t(title), иначе title, иначе id
export function itemTitle(item, lang, t) {
    if (!item || typeof item !== 'object') return item === undefined || item === null ? '' : String(item)
    const loc = lang ? item[`title_${lang}`] : undefined
    if (typeof loc === 'string' && loc !== '') return loc
    const base = item.title
    if (base !== undefined && base !== null && base !== '') return typeof t === 'function' ? String(t(String(base))) : String(base)
    return item.id === undefined || item.id === null ? '' : String(item.id)
}

// ---------- конфигурация ----------
const REQUIRED = ['rows_binding', 'columns_binding', 'cell_table_binding', 'cell_value_binding']
const STR_DEF = { rows_title_binding: 'title', columns_title_binding: 'title', key_binding: 'name', children_path: 'attrs' }
const FLAT_KEYS = ['cell_rows_key_binding', 'cell_columns_key_binding']   // IE 2026 10 25 / ODOO-348925: пути ключей строки и колонки внутри строки плоской таблицы (node.name, field.name)
// cgConfig: параметры — ключи верхнего уровня атрибута (запасной — attr.params.<ключ>); errors: [{code, params?}]
export function cgConfig(attr) {
    const a = attr && typeof attr === 'object' ? attr : {}
    const p = isObj(a.params) ? a.params : {}
    const pick = (k) => (a[k] !== undefined && a[k] !== null && a[k] !== '') ? a[k] : ((p[k] !== undefined && p[k] !== null && p[k] !== '') ? p[k] : undefined)
    const cfg = {}
    for (const k of REQUIRED) cfg[k] = typeof pick(k) === 'string' ? pick(k) : ''
    for (const k of Object.keys(STR_DEF)) cfg[k] = typeof pick(k) === 'string' ? pick(k) : STR_DEF[k]
    for (const k of FLAT_KEYS) cfg[k] = typeof pick(k) === 'string' ? pick(k) : ''   // IE 2026 10 25 / ODOO-348925
    cfg.flat = !!(cfg.cell_rows_key_binding && cfg.cell_columns_key_binding)   // IE 2026 10 25 / ODOO-348925: плоский режим — только когда объявлены ОБА ключа
    const vt = pick('cell_value_attr_type')
    cfg.cell_value_attr_type = vt === 'AttrBool' || vt === 'AttrLink' ? vt : null
    cfg.cell_relation_segment = typeof pick('cell_relation_segment') === 'string' ? pick('cell_relation_segment') : null
    cfg.cell_items_source = Array.isArray(pick('cell_items_source')) ? pick('cell_items_source').filter(isObj) : null
    cfg.cell_create_defaults = isObj(pick('cell_create_defaults')) ? pick('cell_create_defaults') : {}
    const cc = pick('cell_clear')
    cfg.cell_clear = isObj(cc) && Object.keys(cc).length ? cc : null
    cfg.group_rows_editable = pick('group_rows_editable') === true
    cfg.group_columns_cells = pick('group_columns_cells') === true
    cfg.cell_delete_on_clear = pick('cell_delete_on_clear') === true   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка как слайд — вид ячеек, матрица связей): очистка ячейки удаляет строку плоской таблицы (матрица связей); компонент гасит при выключенном fe.ux.crossGridV2
    const w = Number(pick('cell_width'))
    cfg.cell_width = Number.isFinite(w) && w > 0 ? w : CG_DEFAULT_WIDTH
    cfg.rows_header = typeof pick('rows_header') === 'string' ? pick('rows_header') : ''
    // IE 2026 10 25 / ODOO-348925: вид заголовков листов (auto — по ширине листа: слово не влезает — повёрнутый, иначе перенос), потолок высоты повёрнутого
    // заголовка (px), потолок строк текста ячейки при переносе
    const hm = pick('cell_header')
    cfg.cell_header = ['auto', 'vertical', 'wrap', 'none'].includes(hm) ? hm : 'auto'
    // IE 2026 10 25 / ODOO-348925 (проба dev02 fe-2026-10-25-12: потолок 150 px обрезал «…» заголовки delta 1 из 9, delta-nodes 11 из 55): потолок высоты ряда
    // повёрнутых заголовков — header_max_height (прежний ключ cell_header_max — запасной), по умолчанию CG_HDR.maxV (260 px: длиннейший заголовок схемы ~233 px)
    const hx = Number(pick('header_max_height') !== undefined ? pick('header_max_height') : pick('cell_header_max'))
    cfg.header_max_height = Number.isFinite(hx) && hx >= 24 ? hx : CG_HDR.maxV
    cfg.cell_header_max = cfg.header_max_height   // IE 2026 10 25 / ODOO-348925: прежнее имя — то же значение
    const ml = Number(pick('cell_max_lines'))
    cfg.cell_max_lines = Number.isFinite(ml) && ml >= 1 ? Math.floor(ml) : CG_CELL.maxLines
    cfg.kind = 'link'   // уточняет компонент (cellKind)
    const errors = []
    const missing = REQUIRED.filter((k) => !cfg[k])
    if (!cfg.flat && (cfg.cell_rows_key_binding || cfg.cell_columns_key_binding)) missing.push(FLAT_KEYS.find((k) => !cfg[k]))   // IE 2026 10 25 / ODOO-348925: объявлен один ключ из двух
    if (missing.length) errors.push({ code: 'missing', params: missing })
    // cell_clear задан, а после cell_create_defaults очищенная строка всё ещё «выключена» — выбранное значение не включит ячейку
    if (cfg.cell_clear && cfg.cell_value_binding && cfg.key_binding) {
        const probe = cfg.flat ? freshCell('r', 'k', 'x', cfg, false) : { [cfg.key_binding]: 'k', [cfg.cell_value_binding]: 'x' }   // IE 2026 10 25 / ODOO-348925
        Object.assign(probe, cfg.cell_clear)
        // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (проба dev02, D6): как cellPut по очищенной строке — значение пишется ПОСЛЕ патча очистки; поле значения само в cell_clear (горизонты: cell_value_binding = use,
        // cell_clear { use: false }) — выбор включает ячейку сам, без cell_create_defaults: предупреждения нет
        setPath(probe, cfg.cell_value_binding, 'x')
        const own = cellOwnKeys(cfg)   // IE 2026 10 25 / ODOO-348925
        for (const k of Object.keys(cfg.cell_create_defaults)) if (!own.includes(k)) probe[k] = cfg.cell_create_defaults[k]   // IE 2026 10 25 / ODOO-348925
        if (cellIsOff(probe, cfg)) errors.push({ code: 'clear' })
    }
    return { cfg, errors }
}

// findCellDecl: описание колонки cell_value в табличной части cell_table (грид rows_binding → колонка cell_table_binding → колонка cell_value_binding) в виде формы
export function findCellDecl(viewAttrs, cfg) {
    if (!cfg || !cfg.rows_binding || !cfg.cell_table_binding || !cfg.cell_value_binding) return null
    const kids = (n) => (n && Array.isArray(n.attrs)) ? n.attrs : []
    const dfs = (list, pred) => {
        for (const n of list || []) {
            if (!n || typeof n !== 'object') continue
            if (pred(n)) return n
            const r = dfs(kids(n), pred)
            if (r) return r
        }
        return null
    }
    if (cfg.flat) {   // IE 2026 10 25 / ODOO-348925: плоский режим — грид самой таблицы ячеек (doc.node_fields) → колонка cell_value
        const cellGrid = dfs(Array.isArray(viewAttrs) ? viewAttrs : [], (n) => n.binding === cfg.cell_table_binding && kids(n).length > 0)
        return cellGrid ? dfs(kids(cellGrid), (n) => n.binding === cfg.cell_value_binding) : null
    }
    const rowsGrid = dfs(Array.isArray(viewAttrs) ? viewAttrs : [], (n) => n.binding === cfg.rows_binding && kids(n).length > 0)
    if (!rowsGrid) return null
    const flat = `${cfg.cell_table_binding}.${cfg.cell_value_binding}`
    const hit = dfs(kids(rowsGrid), (n) => n.binding === flat)
    if (hit) return hit
    const table = dfs(kids(rowsGrid), (n) => n.binding === cfg.cell_table_binding && kids(n).length > 0)
    return table ? dfs(kids(table), (n) => n.binding === cfg.cell_value_binding) : null
}

// declLeafAttr: описание листа шахматки по объявленной колонке cell_value (AttrLink) — БЕЛЫЙ список ключей: какой словарь и как показывать ссылку. Хуки и поведение колонки
// (action_afterChange, isReadOnly, default, cssClass, width, …) на лист проекции не переносятся: хук колонки грида узлов сработал бы на строке ПРОЕКЦИИ, isReadOnly сделал бы
// всю шахматку только для чтения. Не AttrLink / нет объявления → null (лист — статичный список словаря)
export const DECL_KEEP = ['attr_type', 'relation_segment', 'relation_segment_binding', 'relation_binding', 'relation_id_binding', 'relation_version', 'relation_version_binding',
    'relation_collection', 'itemsSource_source', 'use_itemsSourcesView', 'customValueWarning', 'format']
export function declLeafAttr(decl) {
    if (!decl || typeof decl !== 'object' || decl.attr_type !== 'AttrLink') return null
    const own = {}
    for (const k of DECL_KEEP) if (decl[k] !== undefined) own[k] = clone(decl[k])
    return own
}

// тип ячейки: cell_value_attr_type > объявление колонки > словарь → ссылка > флажок
export function cellKind(cfg, decl, hasDict) {
    const forced = cfg && cfg.cell_value_attr_type
    if (forced === 'AttrBool') return 'bool'
    if (forced === 'AttrLink') return 'link'
    const dt = decl && decl.attr_type
    if (dt === 'AttrBool') return 'bool'
    if (dt === 'AttrLink') return 'link'
    return hasDict ? 'link' : 'bool'
}
// сегмент словаря: параметр cell_relation_segment, иначе relation_segment объявленной колонки
export function dictSegment(cfg, decl) {
    return (cfg && cfg.cell_relation_segment) || (decl && typeof decl.relation_segment === 'string' && decl.relation_segment) || null
}

// IE 2026 10 25 / ODOO-348925: короткая форма элемента словаря для ячейки — short / symbol / short_title / abbr (на языке пользователя: <поле>_<lang>), в самой записи
// или в её doc; нет — '' (ячейка показывает название). Проверено на dev02 25.10: у PLAN-MAP-MODE таких полей нет («Kept», «Exception / reference / calc»),
// у FIELD-ROLE название само короткое («×», «Σ», «i»)
export const CG_SHORT_KEYS = ['short', 'symbol', 'short_title', 'abbr']
export function itemShort(item, lang) {
    if (!isObj(item)) return ''
    for (const host of [item, isObj(item.doc) ? item.doc : null]) {
        if (!host) continue
        for (const k of CG_SHORT_KEYS) { const v = localized(host, k, lang); if (v.trim()) return v.trim() }
    }
    return ''
}
// словарь значений: loaded — записи сегмента ([{id, title, ...}]), list — cell_items_source; описание сегмента, если нет, берётся из list по тому же id
// opt.short (fe.ux.crossGridCellShort) — у элемента поле cell: короткая форма для ячейки (itemShort), иначе — символ; список и подсказка — по-прежнему полным символом
export function dictItems(loaded, list, lang, t, opt = {}) {
    const byId = new Map()
    for (const it of Array.isArray(list) ? list : []) if (it && it.id !== undefined && it.id !== null) byId.set(String(it.id), it)
    const base = (Array.isArray(loaded) && loaded.length) ? loaded : (Array.isArray(list) ? list : [])
    const out = []
    for (const it of base) {
        if (!it || it.id === undefined || it.id === null) continue
        const alt = byId.get(String(it.id))
        const symbol = itemTitle(it, lang, t) || (alt ? itemTitle(alt, lang, t) : '') || String(it.id)
        const description = localized(it, 'description', lang) || (alt ? localized(alt, 'description', lang) : '')
        const cell = (opt.short && (itemShort(it, lang) || (alt ? itemShort(alt, lang) : ''))) || symbol   // IE 2026 10 25 / ODOO-348925
        out.push({ id: it.id, symbol, cell, description, caption: description ? `${symbol}  ${description}` : symbol })
    }
    return out
}

// helpText: текст объяснения записи из record_help (what / why / how — первое непустое); нет — ''
export function helpText(entry) {
    if (!entry || typeof entry !== 'object') return ''
    for (const k of ['what', 'why', 'how']) { const v = entry[k]; if (typeof v === 'string' && v.trim()) return v.trim() }
    return ''
}
// withHelp: словарь с описаниями из record_help там, где своего описания нет (описание самого элемента / cell_items_source главнее); help — { id: текст }
export function withHelp(dict, help) {
    const hp = help || {}
    return (dict || []).map((d) => {
        const text = hp[d.id]
        if (d.description || !text) return d
        return { ...d, description: String(text), caption: `${d.symbol}  ${text}` }
    })
}
// listItems: пункты списка AttrLink (статичный itemsSource): title — СИМВОЛ (по нему же находится введённый текст), справа вместо id — описание на языке пользователя,
// без описания — один символ. Список Dropdown рисует справа item.highlightedID (если он есть), поэтому у пункта аксессор highlightedID: описание (с экранированием),
// запись грида (подсветка найденного) игнорируется. descOf(id) — описание «живьём»: record_help отвечает позже построения
export function listItems(dict, descOf) {
    const get = typeof descOf === 'function' ? descOf : ((id) => { const d = (dict || []).find((x) => String(x.id) === String(id)); return d ? d.description : '' })
    return (dict || []).map((d) => {
        const it = { id: d.id, title: d.symbol }
        Object.defineProperty(it, 'highlightedID', { enumerable: false, configurable: true, get: () => escHtml(get(d.id) || ''), set: () => {} })
        return it
    })
}

// isKnownValue: значение — элемент словаря (id или объект ссылки) либо пусто (очистка). Словарь не загружен — проверить нечем, пропускаем
export function isKnownValue(v, dict) {
    if (!Array.isArray(dict) || !dict.length) return true
    const id = valueId(v)
    if (id === undefined || id === null || id === '' || id === false) return true
    return dict.some((d) => String(d.id) === String(id))
}
// focusLost: фокус страницы потерян (BODY / html / снятый из DOM элемент) — тогда его можно вернуть в грид; фокус в другом месте (поле, меню) не трогаем
export function focusLost(active, body) {
    if (!active || active === body) return true
    if (body && active === body.parentElement) return true
    return typeof active.isConnected === 'boolean' && !active.isConnected
}

// pickOwnGroup: выбор значения из списка (choiceFinish грида) — своя группа отката. AttrGrid склеивает в один шаг Undo / Redo все записи с одним actionStack, а choiceFinish его не увеличивает
// (ввод текста — увеличивает, в cellEditEnding2): подряд выбранные значения и Delete сразу после выбора откатывались бы ОДНИМ нажатием. Обёртка над методом экземпляра грида: после выбора
// actionStack++ (в finally — и при ошибке). Выключатель читается в момент вызова; тот же грид второй раз не оборачивается. true — обёртка поставлена сейчас.
// Многоячеечные действия (Delete по выделению, вставка) идут не через choiceFinish и остаются одной группой — как в обычном гриде.
const PICK_WRAPPED = new WeakSet()
export function pickOwnGroup(grid, isOn, onBump) {
    if (!grid || typeof grid.choiceFinish !== 'function' || PICK_WRAPPED.has(grid)) return false
    const orig = grid.choiceFinish
    grid.choiceFinish = function (...args) {
        try {
            return orig.apply(this, args)
        } finally {
            let on = true
            try { on = typeof isOn === 'function' ? isOn() !== false : true } catch (e) { on = true }
            if (on && typeof grid.actionStack === 'number') {
                grid.actionStack++
                if (typeof onBump === 'function') { try { onBump() } catch (e) { /* счётчик проб */ } }
            }
        }
    }
    PICK_WRAPPED.add(grid)
    return true
}

// CG_GRID_COMMANDS / gridCommandMethods: кнопки командной панели и меню таблицы вложенного грида (Undo, Redo, история, ☰ …) шлют executeVueObjMethod с source_name = имя ВЛОЖЕННОГО грида; оно же имя объявления
// атрибута в форме, а get_vueObj(имя) отдаёт компонент, зарегистрированный под id объявления, — то есть ОБЁРТКУ (вложенный грид без id в реестр не пишется). У обёртки нет undo_Click и прочих методов, и команда
// уходила по запасному пути — к владельцу открытого списка (store.dropdown.vueObj): пока им был вложенный грид, кнопки «случайно» работали; если список последним открывал другой грид (или никто) — клик терялся, а
// у чужого грида откатывалась его собственная правка. Обёртка получает методы-переходники на вложенный грид (имена — как в панели AttrGrid, у каждой кнопки source_name); в реестр вложенный грид не добавляется
// (петли по реестру его не видят, как и раньше). Выключатель fe.ux.crossGridToolbar читается в момент вызова. Cell-form команды (Edit value, Add comment …) source_name не несут и сюда не относятся.
export const CG_GRID_COMMANDS = [
    'undo_Click', 'redo_Click', 'undoHistory_Click', 'redoHistory_Click', 'new_Click', 'clone_Click', 'delete_Click', 'up_Click', 'down_Click', 'left_tab_Click', 'right_tab_Click', 'merge_Click', 'groupAll', 'ungroupAll',
    'aggAll_showAll_toggle', 'metricSet_click', 'onClearCells', 'pastingItems', 'openItemsSourcesView_Click', 'selector_Click', 'copyExcel_copy', 'copyExcel_toggle', 'lightView_toggle', 'restoreDefaultSizes',
    'toggleFeSelected', 'i18n_menu_open', 'testFieldsMapping_Click', 'updateFieldsMapping_Click',
    // copyPaste (Copy rows / cell / … , Deep copy, Copy / Export rows (JSON), Export XLSX / PDF) берёт у grid-объекта эти методы (mainStore: copyPaste → copy_selectedItems, get_selectedRanges, mergeBack_exportOff)
    'copy_selectedItems', 'get_selectedRanges', 'mergeBack_exportOff',
    // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — ⚙ повторно): номер строки — WidgetAttrs.get_selectedRow(binding) зовёт attr_vueObj.iroot(dataItem) у зарегистрированного компонента (обёртки); без переходника
    // selectionChanged вложенного грида при открытой форме вида (⚙) падал TypeError «attr_vueObj.iroot is not a function»
    'iroot',
]
// CG_GRID_PROPS: свойства вложенного грида, которые платформа читает у зарегистрированного компонента: flex (get_flex(binding) → attrs_vueObj[id].flex — выгрузка XLSX / PDF, свёртка …) и formatItemXlsx (передаётся
// конвертеру как функция). Это ЖИВЫЕ геттеры на компоненте-обёртке: вложенный грид (и его wijmo-flex при смене заголовков) может смениться, выключатель fe.ux.crossGridToolbar читается при каждом чтении.
// Реестр attrs_vueObj не меняется — петли по реестру по-прежнему не видят вложенный грид как отдельную запись (flex через обёртку видят те петли, что читают vueObj.flex: фиксация открытого редактора перед действием и т.п.).
export const CG_GRID_PROPS = ['flex', 'formatItemXlsx']
export function defineGridApi(target, getGrid, isOn) {
    for (const k of CG_GRID_PROPS) {
        Object.defineProperty(target, k, {
            configurable: true, enumerable: false,
            get: () => {
                let on = true
                try { on = typeof isOn === 'function' ? isOn() !== false : true } catch (e) { on = true }
                const g = on && typeof getGrid === 'function' ? getGrid() : null
                return g ? g[k] : undefined
            },
        })
    }
    return target
}
// gridCommandCall: вызвать метод вложенного грида с теми же аргументами и вернуть его результат; выключатель снят, грида нет или метода у него нет — undefined (команда ничего не делает, как у объекта без метода)
export function gridCommandCall(name, grid, on, args) {
    if (on === false || !grid || typeof grid[name] !== 'function') return undefined
    return grid[name](...(args || []))
}
// gridCommandMethods: объект методов для options.methods компонента-обёртки; this — компонент ($refs.grid — вложенный грид, store.setting — выключатели)
export function gridCommandMethods() {
    const m = {}
    for (const name of CG_GRID_COMMANDS) {
        m[name] = function (...args) {
            const setting = this && this.store && typeof this.store.setting === 'function' ? (k, d) => this.store.setting(k, d) : undefined
            return gridCommandCall(name, this && this.$refs ? this.$refs.grid : null, crossGridToolbarOn(setting), args)
        }
    }
    return m
}

// trackUndoDir: направление Undo / Redo знает только AttrGrid (changeStack(from, to, 'val' | 'newVal')); сеттер ячейки видит лишь записываемое видимое значение, а у Undo одной записи и Redo следующей оно бывает
// ОДИНАКОВЫМ (Σ → пусто: откат создания и повтор очистки той же ячейки) — по значению направление не определить, и повтор очистки восстанавливал бы «до создания». Пока шаги шли парами (выбор + Delete в одной
// группе) это не проявлялось; с одним шагом на нажатие — проявляется. Обёртка над changeStack экземпляра грида держит направление на время вызова (вложенный вызов возвращает прежнее); undoDir(grid) → 'undo' | 'redo' | null.
const UNDO_DIR = new WeakMap(), DIR_WRAPPED = new WeakSet()
export function trackUndoDir(grid) {
    if (!grid || typeof grid.changeStack !== 'function' || DIR_WRAPPED.has(grid)) return false
    const orig = grid.changeStack
    grid.changeStack = function (fromStack, toStack, nameVal) {
        const prev = UNDO_DIR.get(grid)
        UNDO_DIR.set(grid, nameVal === 'newVal' ? 'redo' : 'undo')
        try {
            return orig.apply(this, arguments)
        } finally {
            if (prev) UNDO_DIR.set(grid, prev); else UNDO_DIR.delete(grid)
        }
    }
    DIR_WRAPPED.add(grid)
    return true
}
export function undoDir(grid) { return (grid && UNDO_DIR.get(grid)) || null }

// escCancel: Esc в редакторе ячейки матрицы при ОТКРЫТОМ списке подбора. Платформа (App.vue и Dropdown.vue, capture на document) тратит такой Esc на закрытие списка и гасит событие: правка не
// отменяется, набранный текст применяется при уходе из ячейки (запись в источник, запись помечена изменённой); отмену делал только второй Esc. Матрица — выбор из словаря: один Esc = закрыть
// список и отменить правку (прежнее значение остаётся, в источник ничего не пишется). Вызывается слушателем окна (capture — раньше App.vue и Dropdown.vue); true — событие обработано.
// Без открытого списка, без редактора этого грида, с модификаторами или во время ввода через IME — false: Esc остаётся штатным (редактор без списка грид отменяет сам).
export function escCancel({ e, flex, dd, on = true } = {}) {
    if (!on || !e || e.key !== 'Escape' || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.isComposing) return false
    if (!flex || !flex.activeEditor || !dd || !dd.visible) return false
    const host = flex.hostElement
    if (!host || typeof host.contains !== 'function' || !host.contains(e.target)) return false
    e.preventDefault(); e.stopImmediatePropagation()
    try { flex.finishEditing(true) } catch (err) { /* грид перестраивается */ }
    try { dd.hide() } catch (err) { /* список уже снят */ }
    return true
}

// rowFitDelta: на сколько px прокрутить, чтобы строка выбранной ячейки целиком лежала в видимой полосе грида (> 0 — вниз, < 0 — вверх, 0 — уже видна). Нужна, потому что
// scrollIntoView грида оставляет последнюю строку под горизонтальной полосой прокрутки, когда видны обе полосы; viewBottom берётся у клиентской области (без полосы)
export function rowFitDelta(r) {
    if (!r || ![r.cellTop, r.cellBottom, r.viewTop, r.viewBottom].every(Number.isFinite)) return 0
    if (r.cellBottom - r.cellTop > r.viewBottom - r.viewTop) return 0   // строка выше окна — не двигаем
    if (r.cellBottom > r.viewBottom + 0.5) return Math.ceil(r.cellBottom - r.viewBottom)
    if (r.cellTop < r.viewTop - 0.5) return -Math.ceil(r.viewTop - r.cellTop)
    return 0
}

// valueId: id значения — голый id или .value / .id объекта ссылки (первый из массива)
export function valueId(v) {
    let x = Array.isArray(v) ? v[0] : v
    if (x && typeof x === 'object') x = x.value !== undefined ? x.value : x.id
    return x
}
export function isEmptyValue(v) {
    const id = valueId(v)
    return id === null || id === undefined || id === '' || id === false
}

// ---------- ячейка в источнике ----------
// findCellRow: строка cell_table с ключом key (сравнение String; при дублях — первая)
export function findCellRow(srcRow, key, cfg) {
    if (cfg.flat) return findFlatRow(srcRow, key, cfg)   // IE 2026 10 25 / ODOO-348925
    const table = getPath(srcRow, cfg.cell_table_binding)
    if (!Array.isArray(table) || key === undefined || key === null || key === '') return { table: Array.isArray(table) ? table : null, index: -1, row: null }
    const k = String(key)
    for (let i = 0; i < table.length; i++) {
        const r = table[i]
        if (r && typeof r === 'object' && String(getPath(r, cfg.key_binding)) === k) return { table, index: i, row: r }
    }
    return { table, index: -1, row: null }
}
// ---------- плоский режим (IE 2026 10 25 / ODOO-348925) ----------
// cellHost: объект, в котором лежит таблица ячеек по cell_table_binding — строка источника (вложенный режим) или запись формы (плоский, cfg.flat_root())
export function cellHost(srcRow, cfg) {
    if (!cfg.flat) return srcRow
    try { const h = typeof cfg.flat_root === 'function' ? cfg.flat_root() : cfg.flat_root; return h && typeof h === 'object' ? h : null } catch (e) { return null }
}
// cellOwnKeys: поля строки ячейки, которые cell_create_defaults не перекрывают — ключ(и) и значение (в плоском режиме — первые сегменты путей ключей)
export function cellOwnKeys(cfg) {
    if (!cfg.flat) return [cfg.key_binding, cfg.cell_value_binding]
    return [String(cfg.cell_rows_key_binding).split('.')[0], String(cfg.cell_columns_key_binding).split('.')[0], cfg.cell_value_binding]
}
// freshCell: новая строка плоской таблицы {<ключ строки>, <ключ колонки>, <значение>, ...defaults}; пути ключей создают объекты (node.name → { node: { name } })
function freshCell(rowKey, colKey, value, cfg, withDefaults = true) {
    const fresh = {}
    setPath(fresh, cfg.cell_rows_key_binding, rowKey)
    setPath(fresh, cfg.cell_columns_key_binding, colKey)
    fresh[cfg.cell_value_binding] = value
    if (withDefaults) {
        const own = cellOwnKeys(cfg)
        for (const k of Object.keys(cfg.cell_create_defaults || {})) if (!own.includes(k)) fresh[k] = clone(cfg.cell_create_defaults[k])
    }
    return fresh
}
// счётчики поиска (window.__cgStats.flat у компонента): число поисков, сборок индекса, время сборок, линейных проходов
export const flatStats = { lookups: 0, indexBuilds: 0, indexMs: 0, scans: 0 }
const FLAT_IDX = new WeakMap()
let FLAT_GEN = 0
// flatIndexReset: ключи строк плоской таблицы могли поменяться не через шахматку (вкладка «Узлы + Поля») — все индексы пересобираются при следующем поиске
export function flatIndexReset() { FLAT_GEN++ }
function flatIndexDrop(table) { if (table && typeof table === 'object') FLAT_IDX.delete(table) }
const pairKey = (a, b) => `${String(a)}\u0001${String(b)}`
function flatMatch(r, rk, ck, cfg) {
    return !!r && typeof r === 'object' && String(getPath(r, cfg.cell_rows_key_binding)) === rk && String(getPath(r, cfg.cell_columns_key_binding)) === ck
}
function flatScan(table, rk, ck, cfg) {
    flatStats.scans++
    for (let i = 0; i < table.length; i++) if (flatMatch(table[i], rk, ck, cfg)) return i
    return -1
}
function flatIndexBuild(table, cfg) {
    const T0 = Date.now(), map = new Map()
    for (let i = 0; i < table.length; i++) {
        const r = table[i]
        if (!r || typeof r !== 'object') continue
        const k = pairKey(getPath(r, cfg.cell_rows_key_binding), getPath(r, cfg.cell_columns_key_binding))
        if (!map.has(k)) map.set(k, i)   // дубли пары — первая строка, как у линейного прохода
    }
    const e = { len: table.length, gen: FLAT_GEN, rk: cfg.cell_rows_key_binding, ck: cfg.cell_columns_key_binding, map }
    FLAT_IDX.set(table, e)
    flatStats.indexBuilds++; flatStats.indexMs += Date.now() - T0
    return e
}
function flatIndexOn(cfg) {
    try { return (typeof cfg.flat_index === 'function' ? cfg.flat_index() : cfg.flat_index) !== false } catch (e) { return true }
}
function flatFind(table, rk, ck, cfg) {
    if (!flatIndexOn(cfg)) return flatScan(table, rk, ck, cfg)
    let e = FLAT_IDX.get(table)
    if (!e || e.len !== table.length || e.gen !== FLAT_GEN || e.rk !== cfg.cell_rows_key_binding || e.ck !== cfg.cell_columns_key_binding) e = flatIndexBuild(table, cfg)
    let i = e.map.get(pairKey(rk, ck))
    if (i !== undefined && !flatMatch(table[i], rk, ck, cfg)) {   // строку по индексу правили мимо шахматки — пересобрать один раз
        e = flatIndexBuild(table, cfg)
        i = e.map.get(pairKey(rk, ck))
    }
    return i === undefined ? -1 : i
}
// findFlatRow: строка плоской таблицы с парой (ключ строки источника, ключ колонки); нет таблицы / ключа — row null
function findFlatRow(srcRow, key, cfg) {
    flatStats.lookups++
    const t = getPath(cellHost(srcRow, cfg), cfg.cell_table_binding)
    const table = Array.isArray(t) ? t : null
    const rk = getPath(srcRow, cfg.key_binding)
    if (!table || !hasKey(rk) || !hasKey(key)) return { table, index: -1, row: null }
    const index = flatFind(table, String(rk), String(key), cfg)
    return index < 0 ? { table, index: -1, row: null } : { table, index, row: table[index] }
}
// flatAudit: строки плоской таблицы, которых нет в матрице (ключ строки или колонки не найден — не видны и при сохранении не трогаются), дубли пары (работает первая),
// дубли ключа строки (вторая строка матрицы только для чтения). vmRows — проекция buildRows, leaves — листья buildColumns
export function flatAudit(vmRows, leaves, table, cfg) {
    const rowKeys = new Set(), dupRows = []
    const walk = (list) => { for (const vm of list || []) { if (vm.cg_key !== null && vm.cg_key !== undefined) rowKeys.add(String(vm.cg_key)); if (vm.cg_dupKey) dupRows.push(vm.cg_key); walk(vm.attrs) } }
    walk(vmRows)
    const colKeys = new Set((leaves || []).filter((l) => l.key !== null && !l.dup).map((l) => String(l.key)))
    const seen = new Set(), dupPairs = []
    let orphans = 0
    for (const r of Array.isArray(table) ? table : []) {
        if (!r || typeof r !== 'object') continue
        const rk = getPath(r, cfg.cell_rows_key_binding), ck = getPath(r, cfg.cell_columns_key_binding)
        if (!hasKey(rk) || !hasKey(ck) || !rowKeys.has(String(rk)) || !colKeys.has(String(ck))) { orphans++; continue }
        const k = pairKey(rk, ck)
        if (seen.has(k)) dupPairs.push({ row: rk, col: ck }); else seen.add(k)
    }
    return { orphans, dupPairs, dupRows }
}
// flatKeysSig: подпись ключей плоской таблицы (длина и пары ключей; значения ячеек не входят) — компонент сбрасывает по ней индекс, когда ключи правят на другой вкладке
export function flatKeysSig(table, cfg) {
    if (!Array.isArray(table)) return 'none'
    let s = String(table.length)
    for (const r of table) s += ';' + (r && typeof r === 'object' ? pairKey(getPath(r, cfg.cell_rows_key_binding), getPath(r, cfg.cell_columns_key_binding)) : '~')
    return s
}

function patchMatches(row, patch) {
    return Object.keys(patch).every((k) => jsonEq(row[k], patch[k]))
}
function applyPatch(row, patch, skip) {
    let changed = false
    for (const k of Object.keys(patch)) {
        if (skip && skip.includes(k)) continue
        if (!(k in row) || !jsonEq(row[k], patch[k])) { row[k] = clone(patch[k]); changed = true }
    }
    return changed
}
// cellIsOff: строки нет; или cell_clear задан и ВСЕ его поля совпадают со строкой; или (cell_clear нет) значение пусто
export function cellIsOff(row, cfg) {
    if (!row || typeof row !== 'object') return true
    if (cfg.cell_clear) return patchMatches(row, cfg.cell_clear)
    const v = getPath(row, cfg.cell_value_binding)
    return cfg.kind === 'bool' ? !v : isEmptyValue(v)
}
export function offValue(cfg) { return cfg.kind === 'bool' ? false : null }
// cellView: значение для показа; выключенная → null (ссылка) / false (флажок)
export function cellView(srcRow, key, cfg) {
    const { row } = findCellRow(srcRow, key, cfg)
    if (!row || cellIsOff(row, cfg)) return offValue(cfg)
    const v = getPath(row, cfg.cell_value_binding)
    if (cfg.kind === 'bool') return !!v
    return v === undefined ? null : v
}
// cellPut: записать значение (как есть); строки нет — добавить в конец {key, value, ...cell_create_defaults}; есть — value + defaults, прочие поля и порядок не трогаются
export function cellPut(srcRow, key, value, cfg) {
    const kb = cfg.key_binding, vb = cfg.cell_value_binding
    let { table, row } = findCellRow(srcRow, key, cfg)
    if (!row && cfg.flat) {   // IE 2026 10 25 / ODOO-348925: плоская таблица записи — новая строка с обоими ключами
        const rk = getPath(srcRow, cfg.key_binding), host = cellHost(srcRow, cfg)
        if (!hasKey(rk) || !hasKey(key) || !host) return { changed: false, created: false, refused: true }
        if (table === null) {
            const cur = getPath(host, cfg.cell_table_binding)
            if (cur !== undefined && cur !== null) return { changed: false, created: false, refused: true }
            setPath(host, cfg.cell_table_binding, [])
            table = getPath(host, cfg.cell_table_binding)
        }
        table.push(freshCell(rk, key, value, cfg))
        flatIndexDrop(table)
        return { changed: true, created: true }
    }
    if (!row) {
        if (table === null) {
            const cur = getPath(srcRow, cfg.cell_table_binding)
            if (cur !== undefined && cur !== null) return { changed: false, created: false, refused: true }
            table = []
            setPath(srcRow, cfg.cell_table_binding, table)
            table = getPath(srcRow, cfg.cell_table_binding)
        }
        const fresh = { [kb]: key, [vb]: value }
        for (const k of Object.keys(cfg.cell_create_defaults || {})) if (k !== kb && k !== vb) fresh[k] = clone(cfg.cell_create_defaults[k])
        table.push(fresh)
        return { changed: true, created: true }
    }
    let changed = false
    if (!jsonEq(getPath(row, vb), value)) { setPath(row, vb, value); changed = true }
    if (!cfg.cell_defaults_create_only && applyPatch(row, cfg.cell_create_defaults || {}, cellOwnKeys(cfg))) changed = true   // IE 2026 10 25 / ODOO-348925 · IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение): другое показанное поле — умолчания строки только при создании
    return { changed, created: false }
}
// cellClear: cell_clear задан — применить патч (use = false), строку НЕ удалять, значение СОХРАНИТЬ; нет — значение в null (ссылка) / false (флажок)
export function cellClear(srcRow, key, cfg) {
    const { table, index, row } = findCellRow(srcRow, key, cfg)   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка как слайд — вид ячеек, матрица связей): + table / index — удаление строки
    if (!row) return { changed: false }
    if (cfg.cell_delete_on_clear && cfg.flat && Array.isArray(table) && index >= 0) { table.splice(index, 1); flatIndexDrop(table); return { changed: true, deleted: true } }   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка как слайд — вид ячеек, матрица связей): cell_delete_on_clear — строка удаляется (точный undo возвращает её на место снимком)
    if (cfg.cell_clear) return { changed: applyPatch(row, cfg.cell_clear, null) }
    const off = offValue(cfg)
    if (jsonEq(getPath(row, cfg.cell_value_binding), off) && (getPath(row, cfg.cell_value_binding) === off)) return { changed: false }
    setPath(row, cfg.cell_value_binding, off)
    return { changed: true }
}
// cellEnable: повторное включение БЕЗ выбора — defaults снова применяются, сохранённое значение возвращается (нет значения — нечего включать)
export function cellEnable(srcRow, key, cfg) {
    const { row } = findCellRow(srcRow, key, cfg)
    if (!row) return cfg.kind === 'bool' ? cellPut(srcRow, key, true, cfg) : { changed: false, created: false }
    if (!cellIsOff(row, cfg)) return { changed: false, created: false }
    if (cfg.kind === 'bool') return cellPut(srcRow, key, true, cfg)
    const v = getPath(row, cfg.cell_value_binding)
    if (isEmptyValue(v)) return { changed: false, created: false }
    return { changed: applyPatch(row, cfg.cell_create_defaults || {}, cellOwnKeys(cfg)), created: false }   // IE 2026 10 25 / ODOO-348925
}
// cellWrite: пусто → очистка, иначе запись. v приходит как есть (id или объект ссылки)
export function cellWrite(srcRow, key, v, cfg) {
    const empty = cfg.kind === 'bool' ? !v : isEmptyValue(v)
    if (empty) { const r = cellClear(srcRow, key, cfg); return { changed: r.changed, created: false, cleared: r.changed } }
    const r = cellPut(srcRow, key, cfg.kind === 'bool' ? true : v, cfg)
    return { changed: r.changed, created: !!r.created, cleared: false, refused: !!r.refused }
}
// точный снимок строки cell_table (или «строки не было») для undo
export function cellSnap(srcRow, key, cfg) {
    const { table, index, row } = findCellRow(srcRow, key, cfg)
    return { hadTable: Array.isArray(table), had: !!row, index, data: row ? clone(row) : null }
}
export function snapEq(a, b) { return jsonEq(a, b) }
export function cellRestore(srcRow, key, cfg, snap) {
    if (!snap) return false
    let { table, index, row } = findCellRow(srcRow, key, cfg)
    const host = cellHost(srcRow, cfg)   // IE 2026 10 25 / ODOO-348925: таблица ячеек — в строке источника или (плоский режим) в записи
    if (!snap.had) {
        if (row) { table.splice(index, 1); if (cfg.flat) flatIndexDrop(table) }   // IE 2026 10 25 / ODOO-348925
        if (!snap.hadTable && Array.isArray(table) && table.length === 0 && host) delPath(host, cfg.cell_table_binding)   // IE 2026 10 25 / ODOO-348925
        return true
    }
    if (!row) {
        if (cfg.flat && !host) return false   // IE 2026 10 25 / ODOO-348925
        if (!Array.isArray(table)) { setPath(host, cfg.cell_table_binding, []); table = getPath(host, cfg.cell_table_binding) }   // IE 2026 10 25 / ODOO-348925
        table.splice(Math.min(Math.max(snap.index, 0), table.length), 0, clone(snap.data))
        if (cfg.flat) flatIndexDrop(table)   // IE 2026 10 25 / ODOO-348925
        return true
    }
    for (const k of Object.keys(row)) if (!(k in snap.data)) delete row[k]
    for (const k of Object.keys(snap.data)) if (!(k in row) || !jsonEq(row[k], snap.data[k])) row[k] = clone(snap.data[k])
    return true
}

// ---------- показ: символ, подсказка ----------
export function cellSymbol(srcRow, key, cfg, dict) {
    const { row } = findCellRow(srcRow, key, cfg)
    if (!row || cellIsOff(row, cfg)) return ''
    const id = valueId(getPath(row, cfg.cell_value_binding))
    if (id === undefined || id === null || id === '') return ''
    const it = (dict || []).find((d) => String(d.id) === String(id))
    return it ? (it.cell || it.symbol) : String(id)   // IE 2026 10 25 / ODOO-348925: короткая форма для ячейки, если есть
}
// cellTip: «<строка> × <колонка>: <символ> — <описание>»; выключенная — «… : not taking part»; текст без разметки (экранирует вызывающий)
export function cellTip(rowTitle, colTitle, item, off, t) {
    const tr = typeof t === 'function' ? t : (s) => s
    const head = `${rowTitle} × ${colTitle}: `
    if (off) return head + tr('not taking part')
    if (!item) return head + '✓'
    return head + item.symbol + (item.description ? ` — ${item.description}` : '')
}

// ---------- структура: колонки и строки ----------
const kidsOf = (row, cfg) => (row && Array.isArray(row[cfg.children_path])) ? row[cfg.children_path] : []
const keyOf = (row, cfg) => getPath(row, cfg.key_binding)
const hasKey = (k) => k !== undefined && k !== null && k !== ''
// buildColumns: дерево описаний колонок для AttrGrid (группа { title, attrs } / лист { binding: cg_<j> }) и список листьев
// opt.leafAttr(leaf) → описание типа листа (attr_type, itemsSource, …); дубль ключа — вторая колонка только чтение; без ключа — без ячейки
export function buildColumns(colRows, cfg, lang, opt = {}) {
    const leaves = [], dupKeys = [], seen = new Set()
    let noKey = 0, j = 0, g = 0
    const leafFor = (row, title, key, depth = 0) => {
        const leaf = { j: j++, key: hasKey(key) ? key : null, binding: '', title, readOnly: false, depth }   // IE 2026 10 25 / ODOO-348925: depth — ряд шапки (0 — верхний)
        leaf.binding = `cg_${leaf.j}`
        if (!hasKey(key)) { leaf.readOnly = true; leaf.noKey = true; noKey++ }
        else if (seen.has(String(key))) { leaf.readOnly = true; leaf.dup = true; dupKeys.push(key) }
        else seen.add(String(key))
        leaves.push(leaf)
        return leaf
    }
    const spec = (leaf, srcRow) => {
        const own = typeof opt.leafAttr === 'function' ? opt.leafAttr(leaf) : { attr_type: 'AttrBool' }
        const tip = leaf.key !== null ? `${leaf.key}${leaf.title && leaf.title !== String(leaf.key) ? ' — ' + leaf.title : ''}` : leaf.title
        return { ...own, binding: leaf.binding, name: leaf.binding, title: leaf.title, tooltip: tip, width: cfg.cell_width, align: 'center', cg_leaf: true, cg_src: undefined }
    }
    const walk = (rows, depth = 0) => {   // IE 2026 10 25 / ODOO-348925: глубина — ряд шапки листа
        const out = []
        for (const row of Array.isArray(rows) ? rows : []) {
            if (!row || typeof row !== 'object') continue
            const key = keyOf(row, cfg)
            const title = localized(row, cfg.columns_title_binding, lang) || (hasKey(key) ? String(key) : '')
            const kids = kidsOf(row, cfg)
            if (kids.length) {
                const gname = `cg_g${g++}`
                const node = { attr_type: 'AttrStr', name: gname, title, cg_group: true }
                if (cfg.group_columns_cells && hasKey(key)) {
                    // у группы своя колонка «↑»: описание листа (тип, список, binding cg_<j>), имя и заголовок — группы
                    Object.assign(node, spec(leafFor(row, title, key, depth), row), { name: gname, title, cg_group: true })
                }
                node.attrs = walk(kids, depth + 1)
                out.push(node)
            } else {
                out.push(spec(leafFor(row, title, key, depth), row))
            }
        }
        return out
    }
    const colAttrs = walk(colRows)
    return { colAttrs, leaves, dupKeys, noKey }
}
// buildRows: дерево проекции строк; cg_src — ссылка на строку источника (не enumerable), cg_path — путь индексов от корня
export function buildRows(rowRows, cfg, lang) {
    const seen = new Set()   // IE 2026 10 25 / ODOO-348925: плоский режим — ключ строки адресует ячейки; повтор ключа — вторая строка только для чтения (cg_dupKey)
    const build = (rows, path) => {
        const out = []
        ;(Array.isArray(rows) ? rows : []).forEach((row, i) => {
            if (!row || typeof row !== 'object') return
            const key = keyOf(row, cfg)
            const kids = kidsOf(row, cfg)
            const vm = {
                cg_title: localized(row, cfg.rows_title_binding, lang) || (hasKey(key) ? String(key) : ''),
                cg_key: hasKey(key) ? key : null,
                cg_path: [...path, i],
                cg_group: kids.length > 0,
            }
            Object.defineProperty(vm, 'cg_src', { value: row, enumerable: false, configurable: true, writable: true })
            if (cfg.flat && hasKey(key)) { if (seen.has(String(key))) Object.defineProperty(vm, 'cg_dupKey', { value: true, enumerable: false, configurable: true, writable: true }); else seen.add(String(key)) }   // IE 2026 10 25 / ODOO-348925
            if (kids.length) vm.attrs = build(kids, vm.cg_path)
            out.push(vm)
        })
        return out
    }
    return build(rowRows, [])
}
// structSig: подпись структуры (ключи, заголовки, вложенность) — значения ячеек не читает
export function structSig(rowRows, colRows, cfg, lang) {
    const sig = (rows, tb) => (Array.isArray(rows) ? rows : []).map((r) => {
        if (!r || typeof r !== 'object') return '~'
        const kids = kidsOf(r, cfg)
        return `${String(keyOf(r, cfg))}|${localized(r, tb, lang)}${kids.length ? '[' + sig(kids, tb) + ']' : ''}`
    }).join(';')
    return `${lang || ''}#${sig(rowRows, cfg.rows_title_binding)}#${sig(colRows, cfg.columns_title_binding)}`
}
// pathToSrc: строка источника по cg_path (цепочка индексов) — проверка живости
export function srcByPath(rowRows, path, cfg) {
    let rows = rowRows, cur = null
    for (const i of path || []) {
        if (!Array.isArray(rows) || !rows[i]) return null
        cur = rows[i]
        rows = kidsOf(cur, cfg)
    }
    return cur
}

// ---------- аксессоры строки проекции ----------
// defineCells: у строки проекции каждый лист — cg_<j> (get = cellView, set = hooks.onWrite), cg_<j>-title (символ) и MD.tooltip[cg_<j>] (подсказка, HTML)
// hooks: { onWrite(vmRow, srcRow, leaf, v), dict() → [{id, symbol, description}], t, rowTitle }
export function defineCells(vmRow, srcRow, leaves, cfg, hooks = {}) {
    const dict = () => (typeof hooks.dict === 'function' ? hooks.dict() : (hooks.dict || []))
    const tip = {}
    const rowRO = !!(cfg.flat && (vmRow.cg_key === null || vmRow.cg_dupKey))   // IE 2026 10 25 / ODOO-348925: плоский режим — строка без ключа или с повтором ключа только для чтения
    for (const leaf of leaves) {
        const live = () => leaf.key !== null
        Object.defineProperty(vmRow, leaf.binding, {
            enumerable: true, configurable: true,
            get: () => (live() ? cellView(srcRow, leaf.key, cfg) : offValue(cfg)),
            set: (v) => {
                if (!live() || leaf.readOnly || rowRO || (vmRow.cg_group && !cfg.group_rows_editable)) return   // IE 2026 10 25 / ODOO-348925
                if (typeof hooks.onWrite === 'function') hooks.onWrite(vmRow, srcRow, leaf, v)
            },
        })
        if (cfg.kind === 'link') {
            Object.defineProperty(vmRow, `${leaf.binding}-title`, {
                enumerable: true, configurable: true,
                get: () => (live() ? cellSymbol(srcRow, leaf.key, cfg, dict()) : ''),
                set: () => {},
            })
        }
        Object.defineProperty(tip, leaf.binding, {
            enumerable: true, configurable: true,
            get: () => {
                if (!live()) return ''
                const off = cellIsOff(findCellRow(srcRow, leaf.key, cfg).row, cfg)
                const id = off ? undefined : valueId(getPath(findCellRow(srcRow, leaf.key, cfg).row, cfg.cell_value_binding))
                // строка включена, а значения нет (use:true, attr_type: null) — «—», не «null»
                const item = id === undefined ? null : (isEmptyValue(id) ? { symbol: '—', description: '' } : (dict().find((d) => String(d.id) === String(id)) || { symbol: String(id), description: '' }))
                const base = escHtml(cellTip(vmRow.cg_title, leaf.title, cfg.kind === 'bool' ? null : item, off, hooks.t))
                const extra = typeof hooks.tipExtra === 'function' ? String(hooks.tipExtra(srcRow, leaf, vmRow) || '') : ''   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (проба dev02, D5): полный текст блока-пилюли (в ячейке может быть «…»)
                return extra ? `${base}<br>${escHtml(extra)}` : base
            },
        })
    }
    Object.defineProperty(vmRow, 'MD', { value: { tooltip: tip }, enumerable: false, configurable: true, writable: true })
    // только чтение штатным каналом грида (is_editable → cf_formatProps → _DLRow): строка-группа целиком, лист с дублем ключа / без ключа — по ячейке; грид отклоняет правку
    // и вставку с видимой пометкой, а не молча
    const cells = {}
    for (const leaf of leaves) if (leaf.readOnly) cells[leaf.binding] = { isReadOnly: true }
    const dl = { cells }
    if ((vmRow.cg_group && !cfg.group_rows_editable) || rowRO) dl.isReadOnly = true   // IE 2026 10 25 / ODOO-348925
    Object.defineProperty(vmRow, '_DLRow', { value: dl, enumerable: false, configurable: true, writable: true })
    return vmRow
}
// defineCellsAll: рекурсивно по дереву проекции (cg_src каждой строки — её источник)
export function defineCellsAll(vmRows, leaves, cfg, hooks) {
    for (const vm of vmRows || []) {
        defineCells(vm, vm.cg_src, leaves, cfg, { ...hooks, rowTitle: vm.cg_title })
        if (Array.isArray(vm.attrs)) defineCellsAll(vm.attrs, leaves, cfg, hooks)
    }
}

// ---------- запись ячейки проекции (вся логика без Vue) ----------
// writeCell: ячейка записана гридом (правка, вставка, протяжка, Delete, Undo / Redo). ctx: { journal, exact (журнал точного undo включён), undoApplying (грид сейчас откатывает), dir ('undo' | 'redo' | null — направление, undoDir), dict }.
// → { kind: 'skip' | 'reject' | 'undo' | 'redo' | 'write' | 'refused', changed, created, cleared }; ctx.dict — словарь [{ id, … }]: значение вне словаря — 'reject'.
// 'skip': грид пишет то же ВИДИМОЕ значение — не правка. Так делает wijmo CollectionView.cancelEdit (Esc при правке строки): он пишет назад ВСЕ перечислимые свойства
// строки, то есть сеттеры всех cg_<j> текущим видимым значением; без этой защиты у строки { use: true, attr_type: null } очистка ставила бы use:false, а у включённой строки
// без use добавлялся бы use:true — и форма помечалась бы изменённой. Откат / повтор (undoApplying) защитой не закрываются.
export function writeCell(live, leaf, vmRow, v, cfg, ctx = {}) {
    const vb = cellView(live, leaf.key, cfg)
    if (!ctx.undoApplying && sameView(v, vb)) return { kind: 'skip', changed: false }
    // ячейка принимает только элементы словаря или пусто: введённый текст («zzz») грид отдаёт как есть (пользовательское значение), в источник он не попадает — ячейка
    // остаётся с прежним значением. Откат / повтор не проверяются: возвращают то, что уже было
    if (!ctx.undoApplying && cfg.kind !== 'bool' && !isKnownValue(v, ctx.dict)) return { kind: 'reject', changed: false }
    if (ctx.exact && ctx.undoApplying && ctx.journal) {
        const m = ctx.journal.match(vmRow, leaf.binding, cellSnap(live, leaf.key, cfg), v, ctx.dir)
        if (m) {
            cellRestore(live, leaf.key, cfg, m.dir === 'undo' ? m.entry.before : m.entry.after)
            m.entry.state = m.dir === 'undo' ? 'undone' : 'applied'
            return { kind: m.dir, changed: true }
        }
    }
    const before = cellSnap(live, leaf.key, cfg)
    const r = cellWrite(live, leaf.key, v, cfg)
    if (r.refused) return { kind: 'refused', changed: false }
    if (!r.changed) return { kind: 'write', changed: false }
    if (ctx.exact && ctx.journal) ctx.journal.record({ vmRow, binding: leaf.binding, before, after: cellSnap(live, leaf.key, cfg), beforeView: vb, afterView: cellView(live, leaf.key, cfg) })
    return { kind: 'write', changed: true, created: !!r.created, cleared: !!r.cleared }
}

// ---------- журнал точного undo ----------
// Запись { vmRow, binding, before, after, beforeView, afterView } — снимки cellSnap и видимые значения до / после записи. AttrGrid откатывает ячейку записью
// СТАРОГО ВИДИМОГО значения через сеттер (undo — a.val, redo — a.newVal); журнал по текущему снимку и этому значению узнаёт запись и направление и возвращает
// ТОЧНЫЙ снимок (строка создания убирается, запомненное значение и порядок строк целы). Одно и то же состояние бывает концом одной записи и началом другой —
// направление различает записываемое видимое значение.
export function sameView(a, b) {
    const ea = isEmptyValue(a), eb = isEmptyValue(b)
    if (ea || eb) return ea && eb
    return String(valueId(a)) === String(valueId(b))
}
export function makeJournal(limit = 500) {
    const items = []
    return {
        items,
        record(entry) {
            for (let i = items.length - 1; i >= 0; i--) if (items[i].state === 'undone') items.splice(i, 1)
            items.push({ ...entry, state: 'applied' })
            if (items.length > limit) items.shift()
        },
        // cur — текущий снимок ячейки, view — видимое значение, которое сейчас пишет грид, dir — направление, если оно известно ('undo' | 'redo', trackUndoDir): тогда ищется только запись этого направления
        // (иначе при совпадении значений побеждал бы откат); без направления — оба, откат первым
        match(vmRow, binding, cur, view, dir) {
            if (dir !== 'redo') for (let i = items.length - 1; i >= 0; i--) {
                const e = items[i]
                if (e.vmRow === vmRow && e.binding === binding && e.state === 'applied' && snapEq(cur, e.after) && sameView(view, e.beforeView)) return { entry: e, dir: 'undo' }
            }
            if (dir !== 'undo') for (let i = 0; i < items.length; i++) {
                const e = items[i]
                if (e.vmRow === vmRow && e.binding === binding && e.state === 'undone' && snapEq(cur, e.before) && sameView(view, e.afterView)) return { entry: e, dir: 'redo' }
            }
            return null
        },
        clear() { items.length = 0 },
    }
}


// ---------- вид листов: заголовок и текст ячейки (IE 2026 10 25 / ODOO-348925, замечания ie-dm7 #104334) ----------
// Шахматка полей — листы по 27–32 px: даже одно слово заголовка («Кількість», «Дистриб’ютор») шире листа, перенос по словам не помогает, а расширение
// листов растянуло бы матрицу в разы — заголовок поворачивается (снизу вверх), высота ряда шапки — по самому длинному заголовку (потолок cell_header_max,
// дальше «…»). Шахматка горизонтов — листы 96 px: слова влезают — перенос по словам, высота ряда шапки — по числу строк. Полный текст — по Alt / Show tooltips.
// pad — поля ячейки по ширине, lineH — шаг строки при переносе, maxLines — потолок строк заголовка, maxV — потолок высоты повёрнутого заголовка, vPad — поля по длине
// IE 2026 10 25 / ODOO-348925 (проба dev02 fe-2026-10-25-12): maxV 150 → 260 (заголовки схемы до ~233 px читаются в одну строку); vPad 10 → 14 (поля 5 + 5 и 4 px запаса
// на расхождение canvas measureText и DOM); v2Line — наименьший шаг колонки повёрнутого заголовка в две колонки (лист ≥ 2 × v2Line + 2 px)
export const CG_HDR = Object.freeze({ pad: 8, lineH: 14, maxLines: 3, maxV: 260, vPad: 14, v2Line: 12 })
// текст ячейки: lineH — шаг строки, pad — поля по высоте, wPad — по ширине, maxLines — потолок строк (cell_max_lines)
export const CG_CELL = Object.freeze({ lineH: 14, pad: 6, wPad: 8, maxLines: 3 })
const words = (text) => String(text ?? '').split(/\s+/).filter(Boolean)
// wrapLines: перенос по словам (жадно) под ширину width; measure(text) → px. Слово шире строки — отдельной строкой (браузер переносит его сам)
export function wrapLines(text, width, measure) {
    const ws = words(text)
    if (!ws.length) return []
    const lines = []
    let cur = ''
    for (const w of ws) {
        const next = cur ? `${cur} ${w}` : w
        if (!cur || measure(next) <= width) cur = next
        else { lines.push(cur); cur = w }
    }
    if (cur) lines.push(cur)
    return lines
}
// headerMode: как показать заголовки листов шириной width. mode — cfg.cell_header; auto: хоть одно слово хоть одного заголовка не влезает — 'vertical',
// хоть один заголовок шире листа — 'wrap', иначе 'none' (всё влезает в строку)
export function headerMode(titles, width, measure, mode = 'auto', o = CG_HDR) {
    if (mode === 'vertical' || mode === 'wrap' || mode === 'none') return mode
    const inner = Math.max(1, width - o.pad)
    let wide = false
    for (const t of titles || []) {
        if (words(t).some((w) => measure(w) > inner)) return 'vertical'
        if (measure(String(t ?? '')) > inner) wide = true
    }
    return wide ? 'wrap' : 'none'
}
// headerHeight: высота ряда шапки листов (px) для режима; base — высота ряда по умолчанию (меньше не бывает); 'none' — base
export function headerHeight(mode, titles, width, measure, base, maxV = CG_HDR.maxV, o = CG_HDR) {
    const b = Number(base) > 0 ? Number(base) : 0
    if (mode === 'vertical') return verticalLayout(titles, width, measure, b, maxV, o).h   // IE 2026 10 25 / ODOO-348925: с переносом в две колонки
    if (mode === 'wrap') {
        let n = 1
        for (const t of titles || []) n = Math.max(n, Math.min(o.maxLines, wrapLines(t, Math.max(1, width - o.pad), measure).length))
        return Math.round(Math.max(b, n * o.lineH + o.pad))
    }
    return b
}
// IE 2026 10 25 / ODOO-348925 (проба dev02 fe-2026-10-25-12): повёрнутый заголовок длиннее потолка — в две колонки текста внутри листа (перенос по словам).
// split2: наименьшая длина строки (px), при которой текст ложится в две строки по словам (лучший разрез); одно слово — Infinity
export function split2(text, measure) {
    const ws = words(text)
    if (ws.length < 2) return Infinity
    let best = Infinity
    for (let i = 1; i < ws.length; i++) best = Math.min(best, Math.max(measure(ws.slice(0, i).join(' ')), measure(ws.slice(i).join(' '))))
    return best
}
// vLine2: шаг колонки (px) повёрнутого заголовка в две колонки на листе width; 0 — лист узок для двух колонок
export function vLine2(width, o = CG_HDR) {
    const l = Math.min(o.lineH, Math.floor((Number(width) - 2) / 2))
    return l >= o.v2Line ? l : 0
}
// verticalLayout: высота ряда повёрнутых заголовков и вид каждого. Порядок: в одну строку, пока влезает в потолок maxV; длиннее — две колонки (если лист
// позволяет, vLine2); и так не влезает — одна строка с «…» (крайний случай; полный текст — по Alt / Show tooltips). Высота — по самому длинному виду, не ниже base.
// → { h, lines: [1 | 2 по заголовкам], cut: [bool], line2 — шаг колонки (px) }
export function verticalLayout(titles, width, measure, base, maxV = CG_HDR.maxV, o = CG_HDR) {
    const b = Number(base) > 0 ? Number(base) : 0
    const cap = Math.max(b, Number(maxV) > 0 ? Number(maxV) : o.maxV)
    const avail = cap - o.vPad
    const line2 = vLine2(width, o)
    const lines = [], cut = []
    let need = 0
    for (const t of titles || []) {
        const m = measure(String(t ?? ''))
        if (m <= avail) { lines.push(1); cut.push(false); need = Math.max(need, m); continue }
        const s2 = line2 ? split2(t, measure) : Infinity
        if (s2 <= avail) { lines.push(2); cut.push(false); need = Math.max(need, s2); continue }
        lines.push(1); cut.push(true); need = Math.max(need, avail)
    }
    return { h: Math.round(Math.max(b, Math.min(need + o.vPad, cap))), lines, cut, line2 }
}
// cellLines: число строк текста ячеек строки (тексты — по листам, ширины — по листам) при переносе по словам, с потолком maxLines; пусто — 1
export function cellLines(texts, widths, measure, maxLines = CG_CELL.maxLines, o = CG_CELL) {
    let n = 1
    ;(texts || []).forEach((t, i) => {
        if (t === undefined || t === null || t === '') return
        const w = Math.max(1, (Array.isArray(widths) ? widths[i] : widths) - o.wPad)
        if (measure(String(t)) <= w) return
        n = Math.max(n, Math.min(maxLines, wrapLines(t, w, measure).length))
    })
    return n
}
// rowHeightFor: высота строки грида по числу строк текста; 1 строка — null (высота по умолчанию)
export function rowHeightFor(lines, base, o = CG_CELL) {
    if (!(lines > 1)) return null
    return Math.round(Math.max(Number(base) || 0, lines * o.lineH + o.pad))
}
// leafHeaderRow: ряд шапки, где стоят заголовки листов (нижний ряд заголовков) — наибольшая глубина листа
export function leafHeaderRow(leaves) {
    let d = 0
    for (const l of leaves || []) if (Number.isFinite(l && l.depth)) d = Math.max(d, l.depth)
    return d
}
